import React from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { CaretDownIcon } from 'components/library';

import './language-selector.scss';

const localeShape = PropTypes.shape( {
    code: PropTypes.string
} );

const SelectArrow = () => <div className="icon"><CaretDownIcon /></div>;
const DropdownIndicator = ( innerProps ) => (
        <components.DropdownIndicator {...innerProps }>
            <SelectArrow />
        </components.DropdownIndicator>
    );

const IndicatorSeparator = ( innerProps ) => {
    const indicatorSeparatorStyle = {
        alignSelf: 'stretch',
        backgroundColor: 'transparent'
    };
    return (
        <span style={indicatorSeparatorStyle} />
    );
};



const customStyles = {
    control: ( base, { isDisabled } ) => ( {
        ...base,
        backgroundColor: '#ffffff',
        borderRadius: 6 + 'px',
        minHeight: 48 + 'px',
        position: 'relative',
        lineHeight: 48 + 'px',
        cursor: 'pointer'
    } ),
    placeholder: ( base, { isDisabled } ) => ( {
        height: 48 + 'px',
        lineHeight: 48 + 'px',
        fontSize: '1em',
        backgroundColor: '#ffffff',
        color: isDisabled ? '#cccccc' : '#353a40'
    } ),
    option: ( base, { isFocused, isDisabled } ) => ( {
        ...base,
        color: isDisabled ? '#cccccc' : isFocused ? '#ffffff' : '#353a40',
        backgroundColor: isFocused ? '#2684ff' : '#ffffff',
        height: 48 + 'px',
        lineHeight: 38 + 'px',
        fontSize: '1em',
        cursor: 'pointer'

      } ),
    singleValue: ( base, { isDisabled } ) => ( {
        height: 48 + 'px',
        fontSize: '1em',
        lineHeight: 38 + 'px',
        paddingLeft: 10 + 'px',
        backgroundColor: '#ffffff',
        color: isDisabled ? '#cccccc' : '#353a40',
    } ),
    dropdownIndicator: base => ( {
        ...base,
        width: 24 + 'px',
        height: 24 + 'px',
        padding: 0,
        color: '#353a40',
        alignItems: 'center',
        paddingTop: 8 + 'px'
    } ),

  };

export default class LanguageSelector extends React.Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        selectedLocale: localeShape,
        options: PropTypes.arrayOf( localeShape ),
        id: PropTypes.string,
        disabled: PropTypes.bool
    }

    static defaultProps = {
        disabled: false
    }

    handleLocaleChange = locale => this.props.onChange( locale );

    render() {
        const {
            selectedLocale,
            options,
            id,
            disabled
        } = this.props;
        return (
            <div className="language-selectors">
                <Select
                    name="Language Preference"
                    autoFocus={ false }
                    isClearable={ false }
                    isDisabled={ disabled }
                    isSearchable={false}
                    isFocused={false}
                    placeholder={ selectedLocale.label }
                    defaultValue={selectedLocale.label}
                    components={ { DropdownIndicator, IndicatorSeparator } }
                    label={ selectedLocale.label }
                    value={ selectedLocale.code }
                    onChange={ this.handleLocaleChange }
                    aria-label="Language Preference"
                    options={ options }
                    styles={ customStyles }
                    closeMenuOnSelect={true}
                    cacheOptions
                    innerProps={ { id: id, readonly: true } }
                />
            </div>
        );
    }
}
